import React, { useLayoutEffect, useState } from "react";
import { Fragment } from "react";
import {
  CalendarIcon,
  EllipsisHorizontalIcon,
  MapPinIcon,
} from "@heroicons/react/20/solid";
import { Menu, Transition } from "@headlessui/react";
import moment from "moment";
import LittleCalendarUpcoming from "./LittleCalendarUpcoming";
import { useSelector } from "react-redux";
import { generateDaysArrayUpComing } from "./calenderUtilties";

const currentMonth = moment().format("YYYY-MM");

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MeetingComponent = ({ meetings, day }) => {
  const [events, setEvents] = useState([]);
  useLayoutEffect(() => {
    let array = meetings.filter(
      (item) =>
        moment(item?.start_time).locale("nl-be").format("YYYY-MM-DD") ===
        moment(day?.date).locale("nl-be").format("YYYY-MM-DD")
    );
    setEvents(array);
  }, [day?.date]);

  return (
    <>
      {events.length > 0 ? (
        <ol className="mt-4 divide-y divide-wa-border text-sm leading-6">
          {events.map((meeting, index) => (
            <li key={index} className="relative flex space-x-6 py-6 xl:static">
              {/* <RP_Avatar avatar={meeting?.user_avatar} size={14} alt={` ${meeting?.user}`} /> */}
              <div className="flex-auto">
                <h3 className="pr-10 font-semibold text-wa-text xl:pr-0">
                  {meeting?.invitees[0]?.name}{" "}
                  <span className="text-xs text-wa-muted">
                    (Specialist: {meeting?.creators[0]?.user_name})
                  </span>
                </h3>
                <dl className="mt-2 flex flex-col text-wa-muted xl:flex-row">
                  <div className="flex items-start space-x-3">
                    <dt className="mt-0.5">
                      <span className="sr-only">Date</span>
                      <CalendarIcon
                        className="h-5 w-5 text-gray-400 dark:text-gray-400"
                        aria-hidden="true"
                      />
                    </dt>
                    <dd>
                      <time dateTime={meeting.start_time}>
                        {moment(meeting.start_time)
                          .locale("nl-be")
                          .format("LL")}{" "}
                        om{" "}
                        {moment(meeting.start_time)
                          .locale("nl-be")
                          .format("HH:mm")}{" "}
                        -{" "}
                        {moment(meeting.end_time)
                          .locale("nl-be")
                          .format("HH:mm")}
                      </time>
                    </dd>
                  </div>
                  <div className="mt-2 flex items-start space-x-3 xl:ml-3.5 xl:mt-0 xl:border-l xl:border-gray-400 xl:border-opacity-50 xl:pl-3.5">
                    <dt className="mt-0.5">
                      <span className="sr-only">Location</span>
                      <MapPinIcon
                        className="h-5 w-5 text-wa-muted"
                        aria-hidden="true"
                      />
                    </dt>
                    <dd>{meeting?.name}</dd>
                  </div>
                </dl>
              </div>
              <Menu
                as="div"
                className="absolute right-0 top-6 xl:relative xl:right-auto xl:top-auto xl:self-center"
              >
                <div>
                  <Menu.Button className="-m-2 flex items-center rounded-full p-2 text-wa-muted hover:text-wa-text">
                    <span className="sr-only">Open options</span>
                    <EllipsisHorizontalIcon
                      className="h-5 w-5"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md border border-wa-border bg-wa-panel2 shadow-lg focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active
                                ? "bg-wa-hover text-wa-text"
                                : "text-wa-muted",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            Edit
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active
                                ? "bg-wa-hover text-wa-text"
                                : "text-wa-muted",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            Cancel
                          </a>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </li>
          ))}
        </ol>
      ) : (
        <div className="mt-4 divide-y divide-wa-border text-sm leading-6 text-wa-muted">
          <span>Geen afspraken beschikbaar op de geselecteerd datum</span>
        </div>
      )}
    </>
  );
};

const UpcomingAgenda = () => {
  const [dayselected, setDayselected] = useState(null);
  const { appointments } = useSelector((state) => state.appointment);

  return (
    <div className="rounded-lg border border-wa-border bg-wa-panel p-4">
      <h2 className="py-2 text-base font-semibold leading-6 text-wa-text">
        Afspraken
      </h2>
      <div className="md:grid md:grid-cols-12 md:gap-x-8 lg:gap-x-12">
        <div className="md:col-span-7 lg:col-span-8 md:order-1">
          <MeetingComponent meetings={appointments} day={dayselected} />
        </div>
        <div className="md:col-span-5 lg:col-span-4 md:order-2">
          <LittleCalendarUpcoming
            currentMonth={currentMonth}
            setDayselected={setDayselected}
            appointments={appointments}
            dayselected={dayselected}
            generateDaysArray={generateDaysArrayUpComing}
          />
        </div>
      </div>
    </div>
  );
};

export default UpcomingAgenda;
